import { SidebarNav } from "./SidebarNav";

/** Desktop sidebar: a floating glass panel with the grouped nav. */
export function Sidebar() {
  return (
    <aside className="sticky top-[74px] hidden h-[calc(100vh-90px)] w-[232px] shrink-0 lg:block">
      <div className="glass flex h-full flex-col rounded-4xl px-3 py-4">
        <nav
          aria-label="Main navigation"
          className="no-scrollbar flex-1 overflow-y-auto pr-1 pt-1"
        >
          <SidebarNav />
        </nav>
      </div>
    </aside>
  );
}
